import axios from 'axios';
import config from 'config';

import paramsSerializer from './paramsSerializer';

let client;

const baseURL = `${config.api.base_url}`;

function createHttpClient() {
  if (!client) {
    // create axios client with custom params serializer
    client = axios.create({
      // baseURL: process.env.REACT_APP_RESAMANIA_API_BASE_URL,
      baseURL,
      paramsSerializer
    });
  }

  return client;
}

export default createHttpClient;



// WEBPACK FOOTER //
// ./src/http-client/axios/createHttpClient.js